/*!
 * React FormControl Library v3.6.0 for FormEngine
 * 
 * Copyright Gars Infotech Private Limited / Xio Infotech Private Limited Foundation and other contributors
 * Released under the MIT license
 * 
 * 
 * Date: 2022-03-02T17:08Z
 * Copyright (c) <2022> <Xio Infotech Private Limited>
 * The MIT License is not the only permissive license. Other well-known permissive licenses include: Apache 2.0, BSD.
 */
 import React, { useContext, useEffect, useState } from 'react'
import { FormContext } from '../Component/Forms/FormContext';
// import  useStyles  from '../Component/Theme_1/FormControlsCss';
import ThemeControls from "../Component/AllThemesControl";
import Button from '@mui/material/Button';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

export default function ButtonToggle(props) {
  const {useStyle} = ThemeControls;
    const classes = useStyle();
    let { id,field_type, field_id,field_apipath,field_disabled, field_label, field_placeholder, field_value, field_options,field_helperText,field_minlength,field_maxlength,field_maxvalue,field_value_type,field_minvalue,field_error_msg_required,field_error_msg_minlength,field_error_msg_maxlength,field_error_msg_minvalue,field_error_msg_maxvalue,field_error_msg_uq,field_mandatory } = props;
    // const { handleChange } = useContext(FormContext)
    const [alignment, setAlignment] = React.useState('and');

    const handleChange = (event) => {
      setAlignment(event.target.value);
    };
  
    return (
      <div className={classes.btntogl}>
      <ToggleButtonGroup
        color="primary"
        value={alignment}
        exclusive
        // onChange={handleChange}
        onClick={(event) => handleChange(event)}
        aria-label="Platform"
      >
        <ToggleButton value="and">AND</ToggleButton>
        <ToggleButton value="or">OR</ToggleButton>
      </ToggleButtonGroup>
      </div>
    );
  }
  